import { Camera } from 'react-bytesize-icons';
import capojs from "../../../../assets/images/docs/meta/capo.png";
import metaOverview from "../../../../assets/images/docs/meta/meta-overview.png";
import missingtags from "../../../../assets/images/docs/meta/missingtags.png";
import sortableSocials from "../../../../assets/videos/docs/meta/sortable-socials.mp4";
import robotsmeta from "../../../../assets/images/blogs/pp251/robotsmeta.png";
import standardsite from "../../../../assets/images/docs/meta/standardsite.png";
import * as React from 'react';
export default {
  Camera,
  capojs,
  metaOverview,
  missingtags,
  sortableSocials,
  robotsmeta,
  standardsite,
  React
};